import { ElementRef } from '@angular/core';
import { Component, OnInit,ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HelpCenterDialogComponent } from 'src/app/components/help-center-dialog/help-center-dialog.component';

@Component({
    selector: 'app-help-center',
    templateUrl: './help-center.component.html',
    styleUrls: ['./help-center.component.scss'],
    standalone: false
})
export class HelpCenterComponent implements OnInit {
  @ViewChild('helpCenterBtn', { static: false }) public helpCenterBtnRef: ElementRef;

  constructor(private matDialog: MatDialog) { }

  ngOnInit(): void {
  }

  openHelpCenterModal(): void {
    this.matDialog.open(HelpCenterDialogComponent,{
      minWidth: '350px',
      backdropClass: 'upgrade-plans-backdrop',
      position : {
        top : this.helpCenterBtnRef.nativeElement.getBoundingClientRect.top,
        right: '30px',
        left: this.helpCenterBtnRef.nativeElement.getBoundingClientRect.left,
        bottom: '10px'
      }
    });
  }

}
